import { notification } from 'antd'

export const isNumber = (value: any) => {
  return typeof value == 'number'
}

export const showSuccess = (message: string) => notification.success({ message })
export const showError = (message: string) => notification.error({ message })
